import React from 'react';
import { Typography } from '@mui/material';
import { ParkingLocation } from 'containers/pages/CANpark/types/parkingLocation';
import {
	ViolationDecision,
	getNextViolationTicketType,
} from 'containers/pages/CANpark/utils/getNextViolationTicketType';
import { useTicketTypeMeta } from 'containers/pages/CANpark/context/TicketTerminologyProvider';

interface NextStepsLabelProps {
	decision: ViolationDecision | ReturnType<typeof getNextViolationTicketType>;
	parkingLocation: ParkingLocation;
}

const NextStepsLabel: React.FC<NextStepsLabelProps> = ({
	decision,
	parkingLocation,
}) => {
	const getTicketTypeMeta = useTicketTypeMeta();
	const isHourly = parkingLocation.violationCheckType === 'hourlyExpiry';

	if (decision.action === 'withinLimit') {
		return (
			<Typography
				component={'span'}
				color={'success.main'}
				fontStyle={'italic'}
			>
				Within time limit — {decision.minutesRemaining} min remaining
			</Typography>
		);
	}
	if (decision.action === 'sessionClosed') {
		return (
			<Typography
				component={'span'}
				color={'text.secondary'}
				fontStyle={'italic'}
			>
				Already actioned this session
			</Typography>
		);
	}

	// The CTA button already shows the action wording (actionText), so the
	// "Next steps:" line uses the description instead — what the operator should
	// physically do — to avoid repeating the same phrase twice.
	const { textColor, description } = getTicketTypeMeta(decision.ticketType);

	if (isHourly) {
		const hourlyText =
			decision.ticketType === 'log'
				? description
				: `Exceeded time limit — ${description.toLowerCase()}`;
		return (
			<Typography component={'span'} color={textColor} fontStyle={'italic'}>
				{hourlyText}
			</Typography>
		);
	}

	return (
		<Typography component={'span'} color={textColor} fontStyle={'italic'}>
			{description}
		</Typography>
	);
};

export default NextStepsLabel;
